<template>
  <div>
    <div class="entry-contents-ttl container-xl text-center">
      <h2>サービスアカウント作成</h2>
    </div>

    <div class="container-xl px-lg-0">
      <div class="row row-flow">
        <div class="col-3">
          <div class="flow-item rounded-start current">メールアドレス<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item current">ワンタイムパス<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item">必要事項<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item">完了</div>
        </div>
      </div>
    </div>

    <!-- ワンタイムパスワード --------------------------- -->
    <main class="container-xl">
      <div class="primary-area">
        <section class="few-contents">
          <div class="contents">
            <h2 class="strong-line">ワンタイムパスを<br class="md">お送りしました！</h2>
            <p >ご入力いただいたメールアドレスに、<span>ワンタイムパスをお送りしました。</span><br>
              受信されたメール内の<span>「<strong>6桁の英数字</strong>」を</span><span>入力してください。</span></p>
            <form @submit.prevent="submit">
              <div class="border-b">
                <div class="one-time-area">
                  <div class="one-time-pass flex"
                    :class="{
                      'form-error': formErrors.emailVerification.getErrorMsg('authCode') !== '',
                    }"
                  >
                    <label>
                      <input
                        type="text"
                        name="otp-01"
                        id="otp-01"
                        maxlength="6"
                        data-politespace
                        data-grouplength="3"
                        v-model="formData.authCode1"
                        placeholder="------"
                      >
                    </label>
                  </div>
                  <div class="small notes notes-error">
                    {{ formErrors.emailVerification.getErrorMsg('authCode') }}
                  </div>
                </div>
              </div>
              <div class="tooltips">
                <Tooltip
                  message="メールが届かない場合は？"
                  tipImageAlt="メールが届かない場合は？"
                >
                  <span>
                    メールが届かない場合は、間違ったメールアドレスを登録しているか、迷惑メールフォルダに振り分けられている可能性があります。ご確認ください。
                  </span>
                </Tooltip>
              </div>
              <Button
                :disabled="!isScreenActive"
              >次へ</Button>
            </form>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "repositories/factory";
import { EmailVerificationCheckAuthCodeValidator } from "validators/email-verifications";
import {
  SignUpRepositoryError,
  IlligalAccessError,
  AuthCodeExpisedError,
  AttemptsExceededError,
  AdminUserAlreadyExistsError,
} from "repositories/modules/sign-up";

import {
  // Icon,
  Tooltip,
  Button,
} from "components";

import {
  TipIcon,
} from "icons";

const SignUpRepository = RepositoryFactory.get("sign-up");

const SCREEEN_STATUS_CD = {
  INITIALIZE: "0",
  ACTIVE: "1",
  PROCESSING: "2",
};

export default {
  name: "EmailValication",
  components: {
    // Icon,
    Tooltip,
    Button,
  },
  data() {
    return {
      icons: {
        TipIcon,
      },
      formData: {
        authCode1: "",
      },
      formErrors: {
        emailVerification: new EmailVerificationCheckAuthCodeValidator(),
      },
    };
  },
  computed: {
    ...mapGetters({
      isScreenActive: "application/isScreenActive",
      signUpEmailVarification: "email-verification/signUpEmailVarification",
    }),
  },
  async created() {
    // サインアップ用のメール認証情報が存在しなければ、メール入力画面に戻る（主にリロード対策）
    if (!this.signUpEmailVarification) {
      this.$router.push({ name: "SignUpSendAuthCode" });
    } else {
      this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
    }
  },
  methods: {
    ...mapActions({
      updateScreenStatusCd: "application/updateScreenStatusCd",
      signUpEmailVerificationEnd: "email-verification/signUpEmailVerificationEnd",
      resetNotification: "notification/resetState",
      setErrorNotification: "notification/setErrorNotification",
    }),
    async submit() {
      try {
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.PROCESSING);
        await this.resetNotification();

        // バリデーション
        const emailVerification = this.signUpEmailVarification;
        emailVerification.authCode = this.formData.authCode1;
        this.formErrors.emailVerification = EmailVerificationCheckAuthCodeValidator.validate(
          emailVerification,
        );

        if (this.formErrors.emailVerification.result) {
          const authentication_id = await SignUpRepository.emailVerification(
            emailVerification.email,
            emailVerification.accessKey,
            emailVerification.authCode,
          );
          // 認証コードの無効化
          await SignUpRepository.endEmailVerification(
            emailVerification.email,
            authentication_id,
          );

          this.$router.push({ name: "SignUpForm" });
          await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
        } else {
          // バリデーションエラー
          await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
        }
      } catch (err) {
        if (err instanceof IlligalAccessError) {
          this.setErrorNotification({
            message: this.$t(`errors.api.sign-up.${err.errorCd}`),
          });
        } else if (err instanceof AuthCodeExpisedError) {
          this.setErrorNotification({
            message: this.$t(`errors.api.sign-up.${err.errorCd}`),
          });
        } else if (err instanceof AttemptsExceededError) {
          this.setErrorNotification({
            message: this.$t(`errors.api.sign-up.${err.errorCd}`),
          });
        } else if (err instanceof SignUpRepositoryError) {
          this.setErrorNotification({
            message: this.$t(`errors.api.sign-up.${err.errorCd}`),
          });
        } else if (err instanceof AdminUserAlreadyExistsError) {
          this.setErrorNotification({
            message: this.$t(`errors.api.sign-up.${err.errorCd}`),
          });
        } else {
          this.setErrorNotification({
            message: "予期せぬエラーが発生しました。",
          });
        }
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
  },
};
</script>
